'use client'

import { useState, useEffect } from 'react'
import MentoringForTeamsHero from './MentoringForTeamsHero'
import { UserWithMentor } from '@/types/mentor'

export default function MentoringForTeamsHeroWrapper() {
  const [floatingMentors, setFloatingMentors] = useState<UserWithMentor[]>([])
  
  useEffect(() => {
    fetch('/api/mentors?limit=12')
      .then(res => res.json())
      .then(data => setFloatingMentors(data))
      .catch(err => console.error('Failed to load mentors:', err))
  }, [])
  
  return <MentoringForTeamsHero floatingMentors={floatingMentors} />
}
